import { useEffect } from "react";
import { motion } from "framer-motion";
import { ShieldCheck, ListChecks, HandPointing } from "@phosphor-icons/react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

const PRINCIPLES = [
  { icon: ShieldCheck, title: "No vendemos tus datos" },
  { icon: ListChecks, title: "Solo lo necesario" },
  { icon: HandPointing, title: "Tú decides" },
];

const Section = ({ title, children }) => (
  <div className="border-b border-black/10 py-8">
    <h2 className="font-semibold text-xl text-[#111418] mb-3">{title}</h2>
    <div className="text-black/60 text-sm leading-relaxed flex flex-col gap-3">{children}</div>
  </div>
);

export const Privacidad = () => {
  useEffect(() => {
    document.title = "Aviso de privacidad - Ruta 360";
  }, []);

  return (
    <div data-testid="privacidad-page" className="bg-white min-h-screen">
      <Header />
      <main className="pt-[100px]">
        <div className="max-w-4xl mx-auto px-6 py-14 lg:py-20">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
            <h1 className="font-display text-5xl sm:text-6xl uppercase font-semibold leading-none tracking-tight text-[#111418] mb-10">
              Aviso de privacidad
            </h1>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-12">
              {PRINCIPLES.map((p) => {
                const Icon = p.icon;
                return (
                  <div key={p.title} className="border border-black/10 bg-white p-6 flex flex-col gap-3">
                    <Icon size={26} weight="regular" className="text-[#FF5508]" />
                    <p className="font-semibold text-sm text-[#111418]">{p.title}</p>
                  </div>
                );
              })}
            </div>

            <Section title="Responsable de tus datos">
              <p>
                Ruta 360 (Ruta Deportiva 360), Xalapa, Veracruz, México. Contacto: pescadeportivamx@gmail.com.
              </p>
              <p>
                Este aviso se emite conforme a la Ley Federal de Protección de Datos Personales en Posesión de los
                Particulares.
              </p>
            </Section>

            <Section title="Qué datos recabamos">
              <ul className="list-disc pl-5 flex flex-col gap-2">
                <li>Formulario de contacto: nombre, correo, teléfono (opcional) y mensaje.</li>
                <li>Cupón de descuento: correo electrónico.</li>
                <li>Pedidos por WhatsApp: nombre, teléfono y dirección para la entrega.</li>
              </ul>
              <p>No pedimos datos sensibles ni guardamos datos de tarjetas bancarias.</p>
            </Section>

            <Section title="Para qué usamos tus datos">
              <p>Responder tus dudas, procesar y enviar tus pedidos y atender garantías.</p>
              <p>
                De manera adicional, podemos enviarte promociones y cupones. Puedes pedir tu baja de estos mensajes
                en cualquier momento.
              </p>
            </Section>

            <Section title="Con quién compartimos tus datos">
              <p>NO vendemos, rentamos ni compartimos tus datos con terceros para fines comerciales.</p>
              <p>
                Solo damos tu nombre, teléfono y dirección a la paquetería (FedEx, Estafeta, DHL o Mercado Libre) para entregar
                tu pedido, y usamos proveedores de hospedaje y correo únicamente para que el sitio funcione.
              </p>
            </Section>

            <Section title="Tus derechos ARCO">
              <p>
                Puedes acceder, rectificar, cancelar u oponerte al uso de tus datos escribiendo a
                pescadeportivamx@gmail.com. Respondemos en un máximo de 20 días hábiles.
              </p>
            </Section>

            <Section title="Cookies">
              <p>Tu navegador guarda tu carrito de compras y si ya viste el cupón de descuento.</p>
            </Section>

            <Section title="Cambios a este aviso">
              <p>Cualquier cambio a este aviso de privacidad se publicará en esta misma página.</p>
              <p className="text-xs text-black/40">
                Última actualización: 3 de octubre de 2026
              </p>
            </Section>
          </motion.div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
